import { Box, Typography, Stack, Chip } from '@mui/material'
import dayjs from 'dayjs'
import type { SeriesModel } from '@common/config/api/client'

interface SeriesInfoProps {
  seriesToProcess: SeriesModel | null
  studyDate: string
  hasSeriesPHI: boolean
  isDrawingMode: boolean
}

export function SeriesInfo({ seriesToProcess, studyDate, hasSeriesPHI, isDrawingMode }: SeriesInfoProps) {
  if (!seriesToProcess) {
    return null
  }

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{seriesToProcess.SeriesDescription}</Typography>
        {hasSeriesPHI && <Chip label="PHI suspected" variant="filled" color="warning-alt" sx={{ borderRadius: 100 }} />}
      </Box>
      <Stack spacing={1} direction="row" mb={2}>
        <Typography color="text.secondary">{dayjs(studyDate, 'YYYYMMDD').format('DD/MM/YYYY')}</Typography>
        <Typography color="text.secondary">•</Typography>
        <Typography color="text.secondary">{seriesToProcess.SeriesNumber}</Typography>
        <Typography color="text.secondary">•</Typography>
        <Typography color="text.secondary">{seriesToProcess.Modality}</Typography>
        <Typography color="text.secondary">•</Typography>
        <Typography color="text.secondary">{seriesToProcess.instances.length} instance(s)</Typography>
      </Stack>

      {/* Mode indicator box - show only when drawing mode is active */}
      {isDrawingMode && (
        <Box
          mt={2}
          sx={{
            backgroundColor: 'rgba(90, 204, 230, 0.1)',
            borderRadius: '4px',
            padding: '8px 16px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography color="info.main">Drawing mode active - Click and drag to create a PHI box</Typography>
        </Box>
      )}
    </>
  )
}
